import { render, staticRenderFns } from "./ProductsLog.vue?vue&type=template&id=7596839e&scoped=true"
import script from "./ProductsLog.vue?vue&type=script&lang=js"
export * from "./ProductsLog.vue?vue&type=script&lang=js"
import style0 from "./ProductsLog.vue?vue&type=style&index=0&id=7596839e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596839e",
  null
  
)

export default component.exports